import React from 'react'
import { motion } from 'framer-motion'

const ProgressBar = ({ 
  value, 
  max, 
  className = '', 
  showLabel = true,
  color = 'primary',
  size = 'md'
}) => {
  const percentage = Math.min((value / max) * 100, 100)
  
  const colors = {
    primary: 'from-primary-400 to-secondary-400',
    success: 'from-success-400 to-highlight-400',
    secondary: 'from-button-secondary to-primary-400',
    accent: 'from-accent-400 to-success-400',
    highlight: 'from-highlight-400 to-primary-400'
  }

  const sizes = {
    sm: 'h-2',
    md: 'h-3',
    lg: 'h-4'
  }

  return (
    <div className={`w-full ${className}`}>
      {showLabel && (
        <div className="flex justify-between text-sm font-medium text-neutral-600 mb-1">
          <span>{value} / {max}</span>
          <span>{Math.round(percentage)}%</span>
        </div>
      )}
      <div className={`bg-neutral-light rounded-full overflow-hidden ${sizes[size]}`}>
        <motion.div
          className={`bg-gradient-to-r ${colors[color]} rounded-full ${sizes[size]}`}
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        />
      </div>
    </div>
  )
}

export default ProgressBar